<script lang="ts" setup>
import type { ICellRendererParams } from 'ag-grid-community';
import type { PropType} from 'vue';
import { computed } from 'vue';
import type { RouteLocationRaw } from 'vue-router';

type AgRouterLinkParams = {
    to: (params: ICellRendererParams) => RouteLocationRaw;
};

type ExtendedParams = ICellRendererParams & AgRouterLinkParams;

const props = defineProps({
    params: {
        type: Object as PropType<ExtendedParams>,
        required: true
    }
});

const routeParams = computed(() => props.params.to(props.params));
</script>

<template>
    <RouterLink
        class="sy-pointer sy-router-link"
        active-class="active"
        :to="routeParams"
    >
        {{ params.value }}
    </RouterLink>
</template>

<style lang="scss" scoped>
    .sy-router-link {
        transition: all 0.2s ease-in-out;
        transform: scale(1);
        display: inline-block;

        &:hover {
            transform: scale(1.035);
        }
    }
</style>
